/*
 * Constants
 ***************************/
 var $ = jQuery.noConflict()
 const mobileBreakpoint = parseInt(wildVars.breakpoints.mobile_max);
 const navBreakpoint = parseInt(wildVars.breakpoints.mobile_navigation_max);
 const windowResizeActions = [];
 let scrollTop = $(window).scrollTop(),
     navTrigger = 0;

 /*
  * Viewport height adjustments
  ***************************/
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
 // We execute the same script as before
 let vh = window.innerHeight * 0.01;
 document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/*
 * Globals
 ***************************/
  /* Window */
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();
    let windowScrollHeight = document.querySelector('body').scrollHeight;
  /* Breakpoints */
    let isMobile = ( windowWidth <= mobileBreakpoint );
    let isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  /* Navigation */
    let isMenuOpen = false,
        isTakeoverMenuOpen = false,
        isSearchOpen = false;

  /* Ajax */
    let currentPage = 1;
    let ajaxIsLoading = false;
    let isDoneLoadingThings = false;
    let currentUrl = window.location.href;

  /* Slick Options */
    const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
    const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';


const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

$(window).on('load', function() {
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
});

$(document).ready(function(){
  const motionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  gsap.registerPlugin(ScrollTrigger, Flip, SplitText);
  
  // ScrollSmoother.create({
  //   smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
  //   effects: true, // looks for data-speed and data-lag attributes on elements
  //   smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices),
  //   onFocusIn: () => {       // check what's in focus, and only return false if it's lastpass?
  //     if ( $(':focus').closest('#smooth-wrapper').length ) {
  //       return true;
  //     }
  //     return false
  //   },
  // });

  /* Generic */
  if ( $('.modal-area').length ) {
    $('.modal-area').each(function(){
      const prop = $(this).data('propid');

      $(this).find('.modal-area__dismiss').on('click', function(){
        $(this).closest('.modal-area').removeClass('active');
        window.localStorage.setItem( prop, 'true' );
      }).on('keypress', handleKeypressADA);

      const element = $(this).get(0);

      $(this).on('click', function(e){
        if (e.target !== element && !element.contains(e.target)) {
          $(this).removeClass('active');
          window.localStorage.setItem( prop, 'true' );
        }
      });

      const modalDismissed = window.localStorage.getItem( prop );
      if ( modalDismissed != 'true' ) {
        const modal = $(this);
        setTimeout(function(){
          modal.addClass('active');
        }, $(this).data('delay'));
      }
    });
  }

  if ( $('.smooth-scroller').length ) { // internal links, smooth scrolling
    $('.smooth-scroller').on('click', function(e){
      e.preventDefault();
      let target = $( $(this).attr('href') ).offset().top - 120;
      let dist = Math.abs($(window).scrollTop() - target);

      $([document.documentElement, document.body]).animate({
        scrollTop: target
      }, Math.min(1200, ((dist / 1200) * 1000)));
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.copybutton').length ) {
    $('.copybutton').on('click', function(e){
      e.preventDefault();
      const targetEl = $( $(this).data('target') ).get(0);
      const alertEl = $( $(this).data('alert') ).get(0);
      targetEl.select()
      targetEl.setSelectionRange(0, 9999999);
      document.execCommand("copy");
      $(alertEl).fadeIn();
      setTimeout(function(){
        $(alertEl).fadeOut();
      }, 6000);
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modaltrigger').length ) {
    $('.modaltrigger').on('click', function(e){
      e.preventDefault();
      $(this).addClass('active');
      $(this).attr('aria-expanded', true );
      $($(this).attr('href')).addClass('active');
      $('#masthead').removeClass('scrolled-back');
      $('#masthead').addClass('scrolled');
      $('body').addClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }

  if ( $('.modalclose').length ) {
    $('.modalclose').on('click', function(e){
      e.preventDefault();
      const controlledBy = $(this).data('controlledby');
      $(this).closest('.modal').removeClass('active');
      $(controlledBy).removeClass('active');
      $(controlledBy).attr('aria-expanded', false);
      $('body').removeClass('no-scroll');
    }).on('keypress', handleKeypressADA);
  }
  /* END GENERIC SCRIPTS */

  /* NAVIGATION SCRIPTS */
  if ( $('.site-header__nav-inner').length ) {
    const navResizeAction = (updated, navUpdated) => {
      if ( navUpdated ) {
        if ( isMobileNavigationActive ) {
          $('#site-nav').attr('role', 'dialog');
          $('#site-nav').attr('aria-modal', 'true');
        } else {
          const navEl = $('#site-nav').get(0);
          navEl.removeAttribute('role');
          navEl.removeAttribute('aria-modal');
        }
      }
    };

    navResizeAction(true, true);
    windowResizeActions.push(navResizeAction);

    const mobileNavContainer = $('.site-header__nav-inner');
    const navInner = mobileNavContainer.get(0);
    const mobileToggle = $('.site-header__nav-toggle');
    const mobileDismiss = $('.site-header__nav-dismiss');
    const firstFocusableMenuElement = $(mobileNavContainer).find('a, button, input').eq(0).get(0);
    const lastFocusableMenuElement = mobileDismiss.get(0);

    const scrollTriggers = {};

    gsap.set('.site-header__nav-inner', {
      '--navigation-width': navInner.clientWidth + 'px'
    });

    $(window).on('resize', function(){
      if ( !$('.site-header__nav-inner').hasClass('condensed') ) {
        gsap.set('.site-header__nav-inner', {
          '--navigation-width': navInner.clientWidth + 'px'
        });
      }
    });

    scrollTriggers['(min-width:' + ( navBreakpoint + 1 ) + 'px)'] = () => {
      ScrollTrigger.create({
        trigger: 'body',
        start: 'top top-=15',
        end: 'bottom top',
        onEnter: () => {
          gsap.to('.site-header__nav-inner', {
            clipPath: 'inset(0 0 0 100% round 1000px 0 0 1000px)',
            duration: 0.8,
            ease: 'power3.inOut'
          });

          gsap.to('.site-header__nav-inner', {
            '--navigation-width': '0px',
            duration: 0.8,
            ease: 'power3.inOut'
          });

          $('.site-header__nav-inner').addClass('condensed');
        },
        onLeaveBack: () => {
          gsap.to('.site-header__nav-inner', {
            clipPath: 'inset(0 0 0 0% round 1000px 0 0 1000px)',
            duration: 0.8,
            ease: 'power3.inOut'
          });

          gsap.to('.site-header__nav-inner', {
            '--navigation-width': navInner.clientWidth + 'px',
            duration: 0.8,
            ease: 'power3.inOut'
          });

          $('.site-header__nav-inner').removeClass('condensed');
        }
      })
    };

    ScrollTrigger.matchMedia(scrollTriggers);

    if ( $(mobileNavContainer).find('.menu-item-has-children') ) {
      $(mobileNavContainer).find('.menu-item-has-children').each(function(){
        const toggle = $(this).children('a, button');
        const submenu = $(this).children('.sub-menu')

        let target = $(toggle).attr('aria-controls');
        let expanded = $(toggle).attr('aria-expanded');

        const toggleResizeAction = (updated, navUpdated) => {
          if ( navUpdated ) {
            if ( isMobileNavigationActive ) {
              $(toggle).attr('aria-controls', target);
              $(toggle).attr('aria-expanded', expanded);
            } else {
              $(toggle).get(0).removeAttribute('aria-controls');
              $(toggle).get(0).removeAttribute('aria-expanded');
            }
          }
        };
        toggleResizeAction(true);

        toggle.on('click', function(){
          if ( isMobileNavigationActive ) {
            expanded = expanded == 'true' ? 'false' : 'true';
            $(toggle).attr('aria-expanded', expanded);
            submenu.slideToggle();
          }
        }).on('keypress', handleKeypressADA);
      });
    }

    $('.site-header__nav-toggle').on('click', function(){
      $(this).toggleClass('active');
      if ( $(this).hasClass('active') ) {
        $(mobileNavContainer).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          opacity: 1,
          onComplete: function(){
            $(mobileNavContainer).focus();
          }
        });
      } else {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          opacity: 0,
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      }
    }).on('keypress', handleKeypressADA);

    $(mobileDismiss).on('click', function(){
      if ( isMobileNavigationActive ) {
        gsap.to(mobileNavContainer, {
          duration: 0.8,
          ease: 'power3.inOut',
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          onComplete: function(){
            $('.site-header__nav-inner').css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });

        $(mobileToggle).removeClass('active');
        $(mobileToggle).focus();
      }
    }).on('keypress', handleKeypressADA);

    $(mobileNavContainer).on('keydown', function(e){
      if ( isMobileNavigationActive ) {
        if ( e.key == 'Escape' ) {
          mobileDismiss.click();
        } else if(e.target == firstFocusableMenuElement && e.key == 'Tab' && e.shiftKey) {
          e.preventDefault();
          lastFocusableMenuElement.focus();
        } else if(e.target == lastFocusableMenuElement && e.key == 'Tab' && !e.shiftKey) {
          e.preventDefault();
          firstFocusableMenuElement.focus();
        }
      }
    });
  }
  /* END NAVIGATION SCRIPTS */

  /* GUTENBERG BLOCK SCRIPTS */
  // gallery
  if ( $('.header-hero.has-background-type-video').length ) {
    $('.header-hero.has-background-type-video').each(function(){
      if ( $(this).closest('.header-carousel').length === 0 ) {
        const video = $(this).find('.header-hero__background video, .header-hero__embed');
        window.localStorage.removeItem("plyr")
        const player = new Plyr(video.get(0), {
          controls: ['play'],
          hideControls: false,
          autoplay: true,
          muted: true,
          playsinline: true,
          loop: {
            active: true
          },
          iconUrl: wildVars.svgSpritesheet,
        });
      }
    });
  }
  
  if ( $('.header-carousel').length ) {
    $('.header-carousel').each(function(){
      const container = $(this).find('.header-carousel__inner');
      const slides = $(this).find('.header-carousel__inner > *');
      const backgrounds = $(this).find('.header-carousel__backgrounds-inner');
      const arrContainer = $(this).find('.header-carousel__controls-arrs');
      const curNum = $(this).find('.header-carousel__controls-nums--cur');
      const totNum = $(this).find('.header-carousel__controls-nums--tot');
      const autoplayToggle = $(this).find('.header-carousel__controls-autoplaytoggle');
      let isAutoplaying = autoplayToggle.hasClass('playing');
      const autoplaySpeed = $(this).data('autoplayspeed');
      
      totNum.text((( slides.length ) + '').padStart(2, '0'));
      
      slides.each(function() {
        if ( $(this).is('.header-hero') ) {
          const clone = $(this).find('.header-hero__background');
          clone.wrap('<div class="header-carousel__backgrounds-slide"></div>');
          
          backgrounds.append(clone.parent());
        }
      });
      
      const players = {
        
      };
      
      $(backgrounds).find('.header-hero__background').each(function(index){
        if ( $(this).is('.is-background-type-video') ) {
          const video = $(this).find('video, .header-hero__embed');
          window.localStorage.removeItem("plyr")
          const player = new Plyr(video.get(0), {
            controls: ['play-large'],
            hideControls: false,
            autoplay: index === 1 ? true : false,
            muted: true,
            playsinline: true,
            loop: {
              active: true
            },
            iconUrl: wildVars.svgSpritesheet,
          });
          
          players[index] = player;
          
          if ( index === 0 ) {
            player.play();
          }
        }
      });
      
      
      backgrounds.on('init', function(){
        if ( players.hasOwnProperty(0) ) {
          players[0].play();
        }
      }).slick({
        fade: true,
        arrows: false
      });
      
      container.slick({
        swipe: false,
        appendArrows: arrContainer,
        asNavFor: backgrounds,
        prevArrow: prevArrow,
        nextArrow: nextArrow
      });
      
      const autoplayTL = gsap.timeline({
        repeat: -1,
        paused: !isAutoplaying,
        onRepeat: function() {
          $(container).slick('slickNext');
        }
      });
      
      $(container).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        curNum.text(((nextSlide + 1) + '').padStart(2, '0'));
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].pause();
        }
        
        if ( isAutoplaying ) {
          autoplayTL.seek(0);
        }
      });
      
      $(container).on('afterChange', function(event, slick, currentSlide){
        if ( players.hasOwnProperty(currentSlide) ) {
          players[currentSlide].play();
        }
      });
       
       
       
      autoplayTL.to($(this).find('.header-carousel__progress-per'), {
        scaleX: 1,
        ease: 'none',
        duration: autoplaySpeed
      });
      
      $(autoplayToggle).on('click', function(){
        isAutoplaying = !isAutoplaying;
        if ( isAutoplaying ) {
          $(autoplayToggle).removeClass('paused');
          $(autoplayToggle).addClass('playing');
          $(this).find('.screen-reader-text').text( $(this).data('pausetext') );
          autoplayTL.play();
          console.log(autoplayTL);
        } else {
          $(autoplayToggle).removeClass('playing');
          $(autoplayToggle).addClass('paused');
          $(this).find('.screen-reader-text').text( $(this).data('playtext') );
          autoplayTL.pause();
        }
      });
    });
  }
  
  if ( $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').length ) {
    $('.wp-block-video, .wp-block-embed.is-provider-youtube, .wp-block-embed.is-provider-vimeo').each(function(){
      const target = $(this).find('video, .wp-block-embed__wrapper');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        controls: $(el).is('video') && el.hasAttribute('controls') ? ( el.getAttribute('controls') === 'false' ? [] : controls ) : ($(el).is('video') ? [] : controls),
        playsinline: el.hasAttribute('playsinline') ? (el.getAttribute('playsinline') === 'true' || el.getAttribute('playsinline') === '') : false,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        muted: shouldAutoplay ? true : ( el.hasAttribute('muted') ? (el.getAttribute('muted') === 'true' || el.getAttribute('muted') === '') : false ),
        iconUrl: wildVars.svgSpritesheet,
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-audio').length ) {
    $('.wp-block-audio').each(function() {
      const target = $(this).find('audio');
      const el = target.get(0);
      
      const controls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'];
      const shouldAutoplay = el.hasAttribute('autoplay') ? (el.getAttribute('autoplay') === 'true' || el.getAttribute('autoplay') === '') : false;
      
      const args = {
        autoplay: shouldAutoplay,
        loop: el.hasAttribute('loop') ? ( (el.getAttribute('loop') === 'true' || el.getAttribute('loop') === '') ? {active: true} : {active: false}) : {active: false},
        iconUrl: wildVars.svgSpritesheet,
      };
      
      const player = new Plyr(el, args);
    });
  }
  
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }
  
  // dropdowns
  if ( $('.wild-dropdown').length ) {
    $('.wild-dropdown').each(function(){
      const container = this;
      const trigger = this.querySelector('.wild-dropdown__toggle');
      const inner = this.querySelector('.wild-dropdown__inner');
      const selectedText = trigger.querySelector('span');
      const optionsList = this.querySelector('.wild-dropdown__dropdown');  
      const options = this.querySelectorAll('.wild-dropdown__dropdown li');
      const hiddenField = this.querySelector('.wild-dropdown__hidden-input');
      const labelEx = options;

      let isExpanded = false;

      $(optionsList).css({
        width: 'auto'
      });

      console.log(  Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px' );
      
      $(inner).css({
        'width': Math.round( ($(optionsList).width() - parseInt($(labelEx).css('padding-left')) - parseInt($(labelEx).css('padding-right')) ) + parseInt($(trigger).css('padding-left')) + parseInt($(trigger).css('padding-right')) ) + 'px'
      });
      
      $(optionsList).css({
        width: '100%'
      });

      /**
        Event handlers
      */
      const handleTriggerKeypresses = function (e) {
        switch(e.key) {
          case 'ArrowUp':
            e.preventDefault();
            
            if(isExpanded) {
              selectPreviousOption();
            } else {
              expandOptions();
            }
            
            break;
            
          case 'ArrowDown':
            e.preventDefault();
            
            if(isExpanded) {
              selectNextOption();
            } else {
              expandOptions();
              selectFirstOption();
            }
            
            break;
            
          case 'Home':
            if(isExpanded) {
              selectFirstOption();
            }
            
            break;
            
          case 'End':
            if(isExpanded) {
              selectLastOption();
            }
            
            break;
            
          case 'Tab':
            collapseOptions();
            break;
            
          case 'Escape':
          case 'Enter':
            if(isExpanded) {
              e.preventDefault();
              collapseOptions();
              if ( e.target.closest('[aria-modal="true"]') !== null ) {
                e.stopPropagation();
              }
            }
            
            break;
        }
      }

      const handleBodyClick = function (e) {
        if(!container.contains(e.target) && isExpanded) {
          collapseOptions();
        }
      }

      const handleTriggerClick = function () {
        if(isExpanded) {
          collapseOptions();
          trigger.focus();
        } else {
          expandOptions();
        }
      }


      /**
        Show/hide option list
      */
      const collapseOptions = function () {
        trigger.setAttribute('aria-expanded', false);
        optionsList.classList.remove('is-visible');
        isExpanded = false;
      }

      const expandOptions = function () {
        trigger.setAttribute('aria-expanded', true);
        optionsList.classList.add('is-visible');
        isExpanded = true;
      }


      /**
        Option selection
      */
      const selectFirstOption = function () {
        var firstOption = options[0];
        selectOption(firstOption);
      }

      const selectLastOption = function () {
        var lastOption = options[options.length-1];
        selectOption(lastOption);
      }

      const selectNextOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex + 1 < options.length) {
            var nextOption = options[currentOptionIndex + 1];
            selectOption(nextOption);
          }
        }
      }

      const selectPreviousOption = function () {
        var currentOption = document.getElementById(trigger.getAttribute('aria-activedescendant'));
        
        if(currentOption !== undefined) {
          var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
          
          if(currentOptionIndex - 1 >= 0) {
            var previousOption = options[currentOptionIndex - 1];
            selectOption(previousOption);
          }
        }
      }

      const selectOption = function (option) {
        unselectAllOptions();
        option.setAttribute('aria-selected', true);
        trigger.setAttribute('aria-activedescendant', option.getAttribute('id'));
        selectedText.innerHTML = option.innerHTML;
        
        // Scroll item into view
        
        
        // Update the hidden field
        hiddenField.value = $(option).data('value');
        $(hiddenField).trigger('change');
      }

      const unselectAllOptions = function () {  
        options.forEach(function(option) {
          option.removeAttribute('aria-selected');
        });
      }

      // Handle keyboard and mouse interactions on the trigger bar
      trigger.addEventListener('keydown', handleTriggerKeypresses);
      trigger.addEventListener('click', handleTriggerClick);
      
      // Select options when they are clicked
      options.forEach(function(option) {
        option.addEventListener('click', function(e) {
          unselectAllOptions();
          selectOption(e.target);
          collapseOptions();
          trigger.focus();
        });
      });
      
      // Collapse the dropdown when the user clicks off
      document.addEventListener('click', handleBodyClick);
    });
  }

  //accordion
  if ( $('.accordion-inner').length ) {
    $('.accordion-inner').each(function(){
      const toggle = $(this).find('.accordion-inner__title button');
      const title = $(this).find('.accordion-inner__title');
      const content = $(this).find('.accordion-inner__content');

      if ( ! content.hasClass('open-on-load') ) {
        content.hide();
      }

      toggle.on('click', function(){
        content.slideToggle();
        const expanded = $(this).attr('aria-expanded');
        $(this).attr('aria-expanded', expanded == 'true' ? 'false' : 'true');
        title.toggleClass('expanded');
      }).on('keypress', handleKeypressADA);
    });
  }

  if ( $('mark.has-inline-color').length ) {
    $('mark.has-inline-color').each(function(){
      if ( $(this).hasClass('given-color') ) return;
      const color = window.getComputedStyle(this).getPropertyValue('background-color');
      $(this).css({
        '--mark-color': color
      });

      $(this).addClass('given-color');
    });
  }
  
  if ( $('.logo-ticker').length ) {
    $('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      
      while ( curW && curW !== 0 && curW < oldSize * 2 ) {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      }
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
      });
    });
  }
  /* END GUTENBERG SCRIPTS */

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort__input-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');

      let updateArchive;
      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        mode: false,
        exclude: exclude,
        taxonomy: false,
        term: false,
        filters: {},
        constantFilters: this.hasAttribute('data-constantfilters') ? $(this).data('constantfilters') : [],
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }
      
      if ( this.hasAttribute('data-taxonomy') ) {
        stateObj.taxonomy = $(this).data('taxonomy');
      }
      
      if ( this.hasAttribute('data-term') ) {
        stateObj.term = $(this).data('term');
      }
      
      if ( this.hasAttribute('data-mode') ) {
        stateObj.mode = $(this).data('mode');
      }
      
      if ( this.hasAttribute('data-searchterm') ) {
        stateObj.search = $(this).data('searchterm');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', stateObj.sort);
        }

        if ( stateObj.mode === 'search' && stateObj.search !== false ) {
          url.searchParams.append('s', stateObj.search);
        } else if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              } else if ( type === 'hidden' ) {
                stateObj.filters[ name ] = $(this).val();
              }
              
              updateURLFromFilters();
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        $(archiveSortInputs).each(function(){
          const val = $(this).attr('value');
          
          if ( $(this).is(':checked') ) {
            stateObj.sort = val;
          }
          
          $(this).on('change', function(){
            if ( $(this).is(':checked') ) {
              stateObj.sort = val;
              updateURLFromFilters();
            }
          });
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }



      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          let parsedNum = false;
          for ( let i = urlparts.length - 1; i >= 0; i-- ) {
            if ( urlparts[ i ] != '' ) {
              const parsed = parseInt( urlparts[ i ] );
              if ( !isNaN(parsed) ) {
                parsedNum = parsed;
                break;
              }
            }
          }

          if ( parsedNum !== false ) {
            page = parsedNum;
          }

          console.log(page);


          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        gsap.to(window, {
          scrollTo: archiveBlock.get(0),
          duration: 0.8,
          ease: 'power1.inOut'
        });


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude,
          taxonomy: stateObj.taxonomy,
          term: stateObj.term,
          mode: stateObj.mode
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        } if ( stateObj.hasOwnProperty('constantFilters') && stateObj.constantFilters.length ) {
          args.constantFilters = stateObj.constantFilters;
        }

        console.log(args);

        $.post(wildVars.ajaxURL, {
          action: 'wild_get_archive',
          args: args
        }, function(data) {
          console.log(data);
          try {
            const res = JSON.parse(data);
            const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
            console.log(res);

            $(archiveFeed).html( res.results );
            $(archivePagination).html( res.pagination );

            Flip.from(state, {
              absolute: true,
              duration: 0.6,
              onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
              onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
            });
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */

  /* SCROLL ANIMATIONS */
  if ( $('.logo-intro').length ) {
    gsap.set('.site-header__logo', {
      opacity: 0,
      pointerEvents: 'none'
    });

    $('.logo-intro').each(function(){
      const headerButton = $('.site-header .wp-block-button');
      const navHasMenu = $('#site-nav-list').length > 0;
      const logo = $(this).find('.logo-intro__logo g');
      const inner = $(this).find('.logo-intro__inner');
      const content = $(this).find('.logo-intro__inner-blocks');
      const computedStyles = window.getComputedStyle(this);
      const bgColor = computedStyles.getPropertyValue('--background-color');
      const textColor = computedStyles.getPropertyValue('--text-color');
      const parentHero = $(this).closest('.header-hero');
      const marks = $(this).find('mark.has-inline-color');
      const markColor = marks.length ? window.getComputedStyle(marks[0]).getPropertyValue('color') : null;
      const header = $('.site-header');
      if ( marks.length ) {
        marks.removeClass('has-off-black-color');
      }

      ScrollTrigger.create({
        trigger: this,
        start: 'top top',
        end: 'bottom top',
        pin: inner,
        pinSpacing: false,
        onEnter: () => {
          header.addClass('is-style-glass');
          if ( headerButton.length ) {
            headerButton.addClass('is-style-glass');
          }
        },
        onLeave: () => {
          header.removeClass('is-style-glass');
          if ( headerButton.length ) {
            headerButton.removeClass('is-style-glass');
          }
        },
      })

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top top',
          end: 'bottom bottom',
          scrub: true,
        }
      });

      timeline.to(logo, {
        scale: 200,
        transformOrigin: 'center center',
        ease: 'power3.in',
        duration: 1.4
      });

      timeline.to(logo, {
        opacity: 0,
        duration: 0.4,
      }, 0.6);

      timeline.to('.site-header__logo', {
        opacity: 1,
        pointerEvents: 'auto',
        duration: 0.4,
      }, 1);

      timeline.to(inner, {
        backgroundColor: bgColor,
        duration: 0.6
      }, 0);
      
      if ( parentHero.length ) {
        timeline.set(parentHero.find('.header-hero__background'), {
          opacity: 0,
        });
      }

      if ( marks.length ) {
        gsap.set(marks, {
          backgroundSize: '0% 100%',
          color: textColor
        });
      }

      timeline.to(content, {
        opacity: 1,
        duration: 0.4,
        onStart: function() {
          if ( marks.length === 0 ) return;
          gsap.fromTo(marks, {
            backgroundSize: '0% 100%',
            color: textColor
          }, {
            backgroundSize: '100% 100%',
            ease: 'expo.inOut',
            color: markColor ? markColor : textColor,
            duration: 0.8,
            stagger: 0.1
          });
        },
      }, 0.9);

      timeline.to({x: 0}, {
        x: 1,
        duration: 0.5
      });

      const outroTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'bottom bottom',
          end: 'bottom center',
          scrub: true,
        }
      });

      outroTimeline.to(inner, {
        opacity: 0,
        duration: 0.6
      });

    });
  }

  if ( $('.picture-flow').length ) {
    $('.picture-flow').each(function(){
      const inner = $(this).find('.picture-flow__inner-blocks');
      gsap.set(inner, {
        y: '-100vh',
        opacity: 0
      });

      ScrollTrigger.create({
        trigger: this,
        start: 'top bottom',
        end: 'bottom bottom',
        pin: inner,
        pinSpacing: false,
        onLeave: () => {
          $(inner).css({
            'mix-blend-mode': 'normal',
            'color': '#000'
          })
        },
        onEnterBack: () => {
          $(inner).css({
            'mix-blend-mode': 'difference',
            'color': '#fff'
          })
        }
      });

      gsap.to(inner, {
        opacity: 1,
        scrollTrigger: {
          trigger: this,
          start: 'top center',
          end: 'top top',
          scrub: true
        }
      });

      gsap.to(inner, {
        opacity: 0,
        scrollTrigger: {
          trigger: this,
          start: 'bottom top',
          end: 'bottom center',
          scrub: true
        }
      });
    });
  }

  if ( $('.masked-video').length ) {
    $('.masked-video').each(function(){
      const background = $(this).find('.masked-video__background');
      const video = background.find('.masked-video__background-inner');
      const inner = $(this).find('.masked-video__inner');
      const buttonContainer = $(this).find('.masked-video__inner .wp-block-button');

      const hasVideoModal = $(this).find('.masked-video__fullvideo-trigger').length > 0;
      const modalTrigger = $(this).find('.masked-video__fullvideo-trigger');
      const modalDismiss = $(this).find('.masked-video__fullvideo-modal__dismiss');
      const modal = $(this).find('.masked-video__fullvideo-modal');
      
      if ( hasVideoModal ) {
        const fullVideo = modal.get(0).querySelector('video, .masked-video__fullvideo-modal__inner-embed');
        window.localStorage.removeItem("plyr")
        const player = new Plyr(fullVideo, {
          hideControls: false,
          autoplay: false,
          muted: false,
          playsinline: true,
          loop: {
            active: false
          },
          iconUrl: wildVars.svgSpritesheet,
        });
        
        modalTrigger.on('click', function(){
          gsap.set(modal, {
            'visibility': 'visible',
            'pointer-events': 'auto',
            'opacity': 0
          });
          
          gsap.to(modal, {
            opacity: 1,
            duration: 0.5,
            onComplete: function() {
              player.play();
            }
          });
        });
        
        modalDismiss.on('click', function(){
          player.pause();
          
          gsap.to(modal, {
            opacity: 0,
            duration: 0.5,
            onComplete: function() {
              gsap.set(modal, {
                'visibility': 'hidden',
                'pointer-events': 'none'
              });
            }
          });
        });
      }

      let height = $(this).height();

      gsap.set(background, {
        clipPath: 'polygon(20% 20%, 80% 20%, 80% 80%, 20% 80%)'
      });

      gsap.set(video, {
        scale: 0.9
      });

      const buttonTimeline = ScrollTrigger.create({
        trigger: this,
        start: 'top top',
        end: 'center center',
        onLeave: () => {
            gsap.to(buttonContainer, {
              opacity: 1,
              onStart: function() {
                gsap.set(buttonContainer, {
                  transition: 'none',
                });
              },
              onComplete: function() {
                gsap.set(buttonContainer, {
                  transition: '',
                })
              }
            });
          },
          onEnterBack: () => {
            gsap.to(buttonContainer, {
              opacity: 0,
              onStart: function() {
                gsap.set(buttonContainer, {
                  transition: 'none',
                });
              },
              onComplete: function() {
                gsap.set(buttonContainer, {
                  opacity: '',
                  transition: '',
                });
              }
            });
          }
      })
      
      const maskTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: this,
          start: 'top top',
          end: 'bottom bottom',
          scrub: true,
          onLeave: () => {
            gsap.to(buttonContainer, {
              opacity: 1,
              onStart: function() {
                gsap.set(buttonContainer, {
                  transition: 'none',
                });
              },
              onComplete: function() {
                gsap.set(buttonContainer, {
                  transition: '',
                })
              }
            });
          },
          onEnterBack: () => {
            gsap.to(buttonContainer, {
              opacity: 0,
              onStart: function() {
                gsap.set(buttonContainer, {
                  transition: 'none',
                });
              },
              onComplete: function() {
                gsap.set(buttonContainer, {
                  opacity: '',
                  transition: '',
                });
              }
            });
          }
        }
      });

      maskTimeline.fromTo(background, {
        clipPath: 'polygon(20% 20%, 80% 20%, 80% 80%, 20% 80%)'
      }, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        ease: 'power3.inOut'
      });

      maskTimeline.fromTo(video, {
        scale: 0.9
      }, {
        scale: 1,
        ease: 'power3.inOut'
      }, 0);
    });
  }

  if ( $('.article-card-container.columns-1.cards-style-featured').length ) {
    $('.article-card-container.columns-1.cards-style-featured').each(function(){
      const cards = $(this).find('.content-card');
      const numCards = cards.length;
      const container = $(this);
      cards.each(function(index){
        if (index === numCards - 1) return;
        const blurTL = gsap.timeline({
          scrollTrigger: {
            trigger: this,
            start: 'bottom bottom-=10',
            endTrigger: container,
            end: 'bottom bottom',
            scrub: true
          }
        });

        blurTL.to(this, {
          filter: 'blur(0px)',
          duration: 0.1
        })

        blurTL.to(this, {
          filter: 'blur(' + ( ((numCards - index) * 4) ) + 'px)',
          duration: 0.4
        })
      });
    })
  }

  if ( $('.margin-block.has-orange-background-color, .alignfull.has-orange-background-color').length ) {
    $('.margin-block.has-orange-background-color, .alignfull.has-orange-background-color').each(function(){
      ScrollTrigger.create({
        trigger: this,
        start: 'top top+=90',
        end: 'bottom top',
        onEnter: () => {
          $('.site-header').addClass('on-orange');
        },
        onLeave: () => {
          $('.site-header').removeClass('on-orange');
        },
        onEnterBack: () => {
          $('.site-header').addClass('on-orange');
        },
        onLeaveBack: () => {
          $('.site-header').removeClass('on-orange');
        }
      })
    });
  }

  // batch primitive animations
  if ( $('.site-footer__contact-inner').length ) {
    $('.site-footer__contact-inner').find('h1, h2, h3, h4, h5, h6, p').addClass('is-style-animate-lines');
  }

  if ( $('.is-style-animate-in, .is-style-animate-lines, .is-style-fade-in, .is-style-slide-in').length ) {
    const animateBlocks = gsap.utils.toArray('.is-style-animate-in, .is-style-animate-lines, .is-style-fade-in, .is-style-slide-in');
    const splits = [];

    animateBlocks.forEach(block => {
      const isFullWidth = $(block).hasClass('alignfull');
      if ( block.classList.contains('is-style-animate-in') ) {
        gsap.set(block.querySelector('img'), {
          clipPath: isFullWidth ? 'polygon(5% 5%, 95% 5%, 95% 95%, 5% 95%)' : 'polygon(10% 10%, 90% 10%, 90% 90%, 10% 90%)'
        });
      } else if ( block.classList.contains('is-style-fade-in') ) {
        gsap.set(block, {
          opacity: 0,
          scale: isFullWidth ? 1 : 0.7,
        });
      } else if ( block.classList.contains('is-style-slide-in') ) {
        gsap.set(block, {
          clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
        });

        gsap.set(block.querySelector('img'), {
          y: '20%',
        });
      } else if ( block.classList.contains('is-style-animate-lines') ) {
        let split = null;
        const textSizeCutoff = 22;
        const textSize = parseInt(window.getComputedStyle(block).fontSize);
        split = SplitText.create(block, {
          types: 'words, lines',
          mask: textSize > textSizeCutoff ? 'lines' : false,
          linesClass: 'heading-line line++',
          autosplit: true,
          onSplit: function(self) {
            if ( !ScrollTrigger.isInViewport(block) && ScrollTrigger.positionInViewport(block, "center") > 1 ) {
              gsap.set(self.lines, {
                y: 56,
                opacity: 0,
              });
            }
          }
        });

        $(window).on('resize', debounce(function(){
          if ( split !== null ) {
            split.revert();
            split.split();
          }
        }));

         
      }
    });

    ScrollTrigger.batch(animateBlocks, {
      start: 'top bottom',
      end: 'bottom top',
      onEnter: batch => {
        let stagger = 0;
        for (let i = 0; i < batch.length; i++) {
          const block = batch[i];
          stagger = i * 0.2;
          if ( block.classList.contains('is-style-animate-in') ) {
            gsap.to(block.querySelector('img'), {
              clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
              ease: 'power3.inOut',
              duration: 0.6,
              delay: stagger
            });
          } else if ( block.classList.contains('is-style-fade-in') ) {
            gsap.to(block, {
              opacity: 1,
              scale: 1,
              ease: 'power3.inOut',
              duration: 0.6,
              delay: stagger
            });
          } else if ( block.classList.contains('is-style-slide-in') ) {
            gsap.to(block, {
              clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
              ease: 'power3.inOut',
              duration: 0.6,
              delay: stagger
            });

            gsap.to(block.querySelector('img'), {
              y: '0%',
              ease: 'power3.inOut',
              duration: 0.6,
              delay: stagger
            });
          } else if ( block.classList.contains('is-style-animate-lines') ) {
            gsap.to(block.querySelectorAll('.heading-line'), {
              y: 0,
              opacity: 1,
              // rotate: '0deg',
              ease: 'expo.out',
              duration: 0.6,
              stagger: 0.1 + stagger
            });
          }
        }
      },
      onLeaveBack: batch => {
        let stagger = 0;
        for (let i = 0; i < batch.length; i++) {
          const block = batch[i];
          const isFullWidth = $(block).hasClass('alignfull');
          stagger = i * 0.2;
          if ( block.classList.contains('is-style-animate-in') ) {
            gsap.set(block.querySelector('img'), {
              clipPath: isFullWidth ? 'polygon(5% 5%, 95% 5%, 95% 95%, 5% 95%)' : 'polygon(10% 10%, 90% 10%, 90% 90%, 10% 90%)',
              ease: 'power3.inOut',
            });
          } else if ( block.classList.contains('is-style-fade-in') ) {
            gsap.set(block, {
              opacity: 0,
              scale: isFullWidth ? 1 : 0.7,
            });
          } else if ( block.classList.contains('is-style-slide-in') ) {
            gsap.set(block, {
              clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)'
            });

            gsap.set(block.querySelector('img'), {
              y: '20%',
            });
          } else if ( block.classList.contains('is-style-animate-lines') ) {
            gsap.set(block.querySelectorAll('.heading-line'), {
              y: 56,
              // rotate: '15deg',
              opacity: 0,
            });
          }
        }
      },
      
    });
  }

  // add anchor link capture here for urls with hashes, to scroll to them with gsap and account for fixed header height
  if ( window.location.hash ) {
    const target = document.querySelector( window.location.hash );
    gsap.set(window, {
      scrollTo: 0
    });

    if ( target ) {
      // calculate duration based on distance to scroll, with a max of 1.5 seconds and a min of 0.5 seconds
      const distance = Math.abs( target.getBoundingClientRect().top );
      const duration = Math.min( Math.max( distance / 1000, 0.5 ), 1.5 );
      gsap.to(window, {
        scrollTo: target,
        duration: duration,
        ease: 'power3.inOut'
      });
    }
  }
}); // document ready end

/*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  let oldState = isMobile;
  let oldNavState = isMobileNavigationActive;
  isMobile = ( windowWidth <= mobileBreakpoint );
  isMobileNavigationActive = ( windowWidth <= navBreakpoint );
  if ( windowResizeActions.length > 0 ) {
    const updated = oldState != isMobile;
    const navUpdated = oldNavState != isMobileNavigationActive;
    for (var i = 0; i < windowResizeActions.length; i++) {
      windowResizeActions[i](updated, navUpdated);
    }
  }
}); // end window resize functions

/*
 * Window Scroll
 ***************************/
$(window).on('scroll', function() {
  navTrigger = scrollTop;
  scrollTop = $(this).scrollTop();
}); // end window scroll functions

/*
 * Functions
 ***************************/
function gutenbergSlickify(el) {
  const count = $(el).find('figure').length;

  $(el).wrap('<div class="slick-gallery-wrapper gallery-title"></div>');
  const wrapper = $(el).parent().get(0);
  
  let slides = $(el).children();
  let numSlides = slides.length;
  
  $(el).find('.wp-block-image').wrap('<div></div>');

  const captions = [];

  let hasAnyCaptions = false;
  $(el).find('figure').each(function(){
    if ( $(this).find('figcaption').length ) {
      $(this).addClass('has-caption');
      captions.push( $(this).find('figcaption').clone(true) );
      $(this).find('figcaption').remove();
      hasAnyCaptions = true;
    } else {
      captions.push('<div style="height:10px;"></div>');
    }
  });

  $(el).find('.blocks-gallery-item').each(function(){
    $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
  });

  $(el).find('.blocks-gallery-item__caption').each(function(){
    $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
  });

  $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

  $(el).removeClass('wp-block-gallery').wrap('<div></div>');
  const parent = $(el).parent();
  parent.addClass('slick-gallery').removeClass('wp-block-gallery').prepend('<div class="slick-gallery-nav"><div class="slick-gallery-nav__arrows gallery-title__controls"></div><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');

  const nav = $(el).parent().find('.slick-gallery-nav');
  const captionsContainer = nav.find('.slick-gallery-nav__captions');
  const arrowsContainer = nav.find('.slick-gallery-nav__arrows');
  for (let i = 0; i < captions.length; i++) {
    captionsContainer.append( captions[i] );
  }

  if ( !hasAnyCaptions ) {
    captionsContainer.hide();
  }

  captionsContainer.slick({
    adaptiveHeight: true,
    arrows: false,
    swipe: false,
    drag: false,
    fade: true,
    speed: 900,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          speed: 600
        }
      }
    ]
  });

  $(el).slick({
    adaptiveHeight: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    appendArrows: arrowsContainer,
    arrowsPlacement: 'beforeSlides',
    asNavFor: captionsContainer,
    variableWidth: true,
    speed: 900,
    cssEase: 'cubic-bezier(0.77,0,0.18,1)',
    
    responsive: [
      {
        breakpoint: 767,
        settings: {
          variableWidth: false,
          speed: 600,
        }
      }
    ]
  });
}

function debounce(func){
  var timer;
  return function(event){
    if(timer) clearTimeout(timer);
    timer = setTimeout(func,100,event);
  };
}

